import { Component, ViewChild } from '@angular/core';
import { IonicPage, ToastController, LoadingController } from 'ionic-angular';
import { APIOnLine } from '../../services/api/api.services';
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { SignatureComponent } from '../../components/signature/signature';
import { iConfiguracion } from '../../models/basePage';
import { Online } from '../../models/online/cfutbol';
import { PaginaBasica } from '../../models/PaginaBase';

@IonicPage()
@Component({
  selector: 'page-ajustes',
  templateUrl: 'ajustes.html',
})
export class AjustesPage extends PaginaBasica {

  //#region Propiedades del controlador
  public arbitro: pouchdb2.ArbitroBasicoDB | Online.ArbitroBasico;
  public configuracion: iConfiguracion;
  public firma: string = '';
  public arbitroActual: string = 'arbitro';
  public uuid: string = '';
  public plataforma: string = '';
  public versionApp: string = "";

  // Acceso a los componentes de la firma
  @ViewChild(SignatureComponent)
  private signatureComponent: SignatureComponent;
  //#endregion

  constructor(
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public Persistentes: APIOnLine.Persistentes
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    this.arbitro = this.Persistentes.GetArbitro();

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        this.configuracion = resultado;
        this.firma = this.Persistentes.GetArbitro().firma;
      })
      .catch(error => this.Error(error, "ERROR obteniendo la configuración de la APP"));
  }

  //#region Métodos del controlador

  /**
   * Elimina la firma, tanto del canvas como de la designación
   */
  public EliminarFirma(): void {
    this.signatureComponent.signaturePad.clear();
    this.firma = "";

    this.arbitro.firma = this.firma;
  }

  public FirmaInicializada($event: boolean): void {
    this.signatureComponent.signaturePad.fromDataURL(this.firma);
  }

  public GuardarFirma(): void {
    this.firma = this.signatureComponent.signaturePad.toDataURL("image/png");
    this.arbitro.firma = this.firma;

    this.CFutbolActas.guardarFirmaArbitro(this.arbitro)
      .then((resultado:boolean) => {
        this.Mensaje("Se ha realizado correctamente el guardado de la firma.", 6000);
      })
      .catch(error => this.Error(error, "ERROR al realizar el guardado de la firma del árbitro."))
  }
  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/ajustes/ajustes.ts